/** Venue address + Google Maps links (share link from Google Maps). */
export const VENUE_LOCATION = {
  name: 'The Sports Hub',
  address: 'Gopinath Marga, Biratnagar 2',
  phones: ['9715384999', '9815384999'] as const,
  facebookUrl: 'https://www.facebook.com/sportshubbiratnagar/',
  /** Short share URL provided by Google Maps */
  mapsUrl: 'https://share.google/yp24bL9DG4vRMruSP',
  lat: 26.4669096,
  lng: 87.28242,
  /** Embeddable map (no API key required) */
  embedUrl:
    'https://www.google.com/maps?q=26.4669096,87.28242&z=17&hl=en&output=embed',
} as const;
